import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import { useModifyContactField } from '../../../../sic-lib/api/hooks/useContact';
import { Contact, buildUpdateContact } from '../../../../sic-lib/types/Contact';
import { useAppDispatch } from '../../../../store/hooks';
import { createToast } from '../../../../store/notify';
import { createErrorToast } from '../../../../utils/notifyHelpers';
import DialogModifyContactNameRaw from '../DialogModifyContactNameRaw/DialogModifyContactNameRaw';
import MenuModifyContactNameAction from '../MenuModifyContactNameAction/MenuModifyContactNameAction';

interface Props {
    contact: Contact;
}

export default function DialogModifyContactName({ contact }: Props) {
    const dispatch = useAppDispatch();

    const { mutate: modifyContactField } = useModifyContactField(contact.contactId);

    const [name, setName] = React.useState<{
        firstName: string;
        lastName: string;
    }>({ firstName: '', lastName: '' });

    React.useEffect(() => {
        setName({
            firstName: contact.firstName || '',
            lastName: contact.lastName || '',
        });

        return () => {
            setAnchorEl(null);
        };
    }, [contact]);

    const menuId = `menu_contact_name_${contact.contactId}`;

    const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

    const [toggle, setToggle] = React.useState<boolean>(false);

    const checkStringIsNotEmpty = (value: string): boolean => {
        if (value === undefined || value === null || value.length === 0) {
            return false;
        }
        return true;
    };

    const handleSubmit = async (firstName: string, lastName: string) => {
        if (!checkStringIsNotEmpty(firstName.trim())) {
            /* Notify user of first name can not be empty */
            const toastData = createErrorToast('First name can not be empty');
            dispatch(createToast({ toastData }));
        } else {
            const fName = buildUpdateContact({
                leadId: contact.contactId,
                fieldType: 0,
                fieldId: 13,
                value: firstName,
            });

            const lName = buildUpdateContact({
                leadId: contact.contactId,
                fieldType: 0,
                fieldId: 14,
                value: lastName,
            });

            //update contact name
            modifyContactField(fName);
            modifyContactField(lName);

            setName({ firstName: firstName, lastName: lastName });
        }

        setToggle(false);
    };

    const handleToggle = () => {
        setToggle(!toggle);
    };

    const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <React.Fragment>
            <Typography component="span" variant="caption" noWrap>
                Name
            </Typography>
            <Grid container justifyContent="space-between" alignItems="center">
                {!toggle ? (
                    <>
                        <Typography component="p" variant="body1" noWrap>
                            {name.firstName} {name.lastName}
                        </Typography>
                        <MenuModifyContactNameAction
                            anchorEl={anchorEl}
                            menuId={menuId}
                            onOpenHandler={handleOpen}
                            onCloseHandler={handleClose}
                            onToggleHandler={handleToggle}
                        />
                    </>
                ) : (
                    <DialogModifyContactNameRaw
                        menuId={menuId}
                        firstName={name.firstName}
                        lastName={name.lastName}
                        onCloseHandler={handleToggle}
                        onSubmitHandler={handleSubmit}
                    />
                )}
            </Grid>
        </React.Fragment>
    );
}
